module.exports = __webpack_public_path__ + "static/media/skoteino-nepal-writer.552daef5.jpg";